<template>
  <v-dialog v-model="dialog" v-bind="$attrs">
    <v-card>
      <v-card-title
        class="headline lighten-2"
        :class="{'green': model.status === 'invalid', 'amber': model.status !== 'invalid'}"
        primary-title>
          <span v-if="model.status === 'invalid'">Restore To Valid</span>
          <span v-else>Mark as Invalid</span>
      </v-card-title>
      <v-card-text>
        <slot name="info"></slot>
        <p v-if="model.status !== 'invalid'">Marking as invalid will cause this item to be skipped during plate generation.</p>
        <p v-else>Restoring back to valid.</p>
      </v-card-text>
      <v-divider v-if="$slots.info"></v-divider>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap column>
            <v-flex xs12 sm6 md4>
              <v-textarea box v-model="model.comments" label="Comment" hide-details type="textarea"></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="close">Cancel</v-btn>
        <v-btn color="primary" flat @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CultureAPI from '@/api/culture.js'
export default {
  props: ['title', 'item'],
  data () {
    return {
      model: {},
      dialog: false
    }
  },
  methods: {
    save () {
      const {item} = this
      const changes = {comments: this.model.comments, status: this.model.status === 'invalid' ? null : 'invalid'}
      CultureAPI.patch(this.model.culture_id, changes)
      this.$emit('save', {item, changes})
      this.$emit('close')
    },
    close () {
      this.$emit('close')
    },
    setModel (item) {
      this.model = JSON.parse(JSON.stringify(item))
    }
  },
  watch: {
    item (val) {
      if (val) {
        this.setModel(val)
        this.dialog = true
      } else {
        this.dialog = false
      }
    }
  }
}
</script>

<style>

</style>
